import lodashFind from 'lodash/find'

export const findById = <T, U extends { id: T }>(array: U[], id: T): U | undefined =>
    lodashFind(array, (obj) => obj.id === id)
